module.exports = __webpack_public_path__ + "media/images/emblems/Grandcour-coat_of_arms-bd2409c38a4ea9bff81e9cfbba12d755.svg";